// ------------it is working code

import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ImageInput, ImagePreview } from "utils/imagePreviewURLConverter";
import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import { CommonSelect, Input, TextArea } from "common/InputForm";
import { v4 as uuid } from "uuid";

import "../product-management.scss";
import {
  addNewProductApi,
  getMasterBrandData,
  getMasterCategoryData,
  getMasterProductType,
  getMasterSubCategoryData,
  getMasterUnitValue,
} from "services/product-management";
import multiImgUploadToCloudFun from "components/modals/multiImageToCloud";
import JoditEditor from "jodit-react";
import {
  multiSubSubCategoryListApi,
  subCategoryListApi,
} from "services/subCategory";
import { MdOutlineCancel } from "react-icons/md";
import { IoChevronBack } from "react-icons/io5";

const AddNewProduct = () => {
  const blank = () => ({
    id: uuid(),
    mrp: "",
    unit: "",
    unitValue: "",
    quantity: "",
    StockValue: "",
    highStockValue: "",
    outOfStock: false,

    outOfStockValue: "",
  });
  const [variants, setVariants] = useState([blank()]);
  const editor = useRef(null);
  const navigate = useNavigate();

  const [error, setError] = useState({});

  // -----cloud img
  //   const [imgInputState, setImageInputState] = useState("");
  const [imgInputState, setImageInputState] = useState([]);

  // ---------------------apply coupon input Checkbox

  const [discountApply, setDiscountApply] = useState(false);
  const [couponNumberState, setCouponNumberState] = useState(0);

  //   -------Right side part

  const [productName, setProductName] = useState("");
  const [saltComposition, setSaltComposition] = useState("");

  const imgUploadFunction1 = async (e) => {
    try {
      const data = await multiImgUploadToCloudFun(e?.target?.files);
      // console.log("1st data?.data[0]:-------->", data?.data[0]);
      if (data?.status === 200) {
        //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
        //   setImageInputState(data?.data[0]);
        setImageInputState(data?.data);

        // seImgPreviewState(e?.target?.files[0]);
        // seImgPreviewState(e?.target?.files[0]);
        setImgPreviewState((prev) => [
          ...prev,
          ...Array.from(e?.target?.files).map((file) =>
            URL.createObjectURL(file),
          ),
        ]);
      }
    } catch (error) {
      console.log("error while uploading and getting data", error);
    }

    // if (!e?.target?.files[0]?.type.includes("image/")) {
    //   setError((stateProp) => ({
    //     ...stateProp,
    //     imgErrorOccur: "Please Choose Image file not others",
    //   }));
    // } else {
    //   try {
    //     const data = await imgUploadToCloudFun(e?.target?.files);
    //     // console.log("1st data?.data[0]:-------->", data?.data[0]);
    //     if (data?.status === 200) {
    //       //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
    //       //   setImageInputState(data?.data[0]);
    //       setImageInputState(data?.data);

    //       seImgPreviewState(e?.target?.files[0]);
    //     }
    //   } catch (error) {
    //     console.log("error while uploading and getting data", error);
    //   }
    // }
  };

  const imgUploadFunction = async (e) => {
  try {
    const files = e?.target?.files;
    const data = await multiImgUploadToCloudFun(files);

    if (data?.status === 200) {
      setImageInputState(data?.data);

      setImgPreviewState((prev) => [
        ...prev,
        ...Array.from(files).map((file) => URL.createObjectURL(file)),
      ]);

      // NEW: this was missing — track uploaded file names
      setImgFileNames((prev) => [
        ...prev,
        ...Array.from(files).map((file) => file.name),
      ]);
    }
  } catch (error) {
    console.log("error while uploading and getting data", error);
  }
};

  // -------------master api data Call

  const [masterBrandState, setMasterBrandState] = useState([]);
  const [masterProductTypeState, setMasterProductTypeState] = useState([]);
  const [masterSubCategoryState, setMasterSubCategoryState] = useState([]);
  const [masterCategoryState, setMasterCategoryState] = useState([]);
  // console.log('masterSubCategoryState', masterSubCategoryState)

  // -----------description state

  const [descriptionState, setDescriptionState] = useState("");

  // --------------------------data

  const [selectedBrandOptionByAdmin, setSelectedBrandOptionByAdmin] =
    useState("");
  const [
    selectedProductTypeOptionByAdmin,
    setSelectedProductTypeOptionByAdmin,
  ] = useState("");

  const [selectedCategoryOptionByAdmin, setSelectedCategoryOptionByAdmin] =
    useState([]);

  const [multiSelectOptions, setMultiSelectOptions] = useState([]);
  const [subSubCategoryList, setSubSubCategoryList] = useState([]);
  const [subSubCategoryValue, setSubSubCategoryValue] = useState([]);
  // console.log({ subSubCategoryValue, multiSelectOptions, subSubCategoryList })
  const [masterUnitState, setMasterUnitState] = useState([]);
  const [imgFileNames, setImgFileNames] = useState([]);


  //   ----------------checkbox relATED
  const [hotDealApply, setHotDealApply] = useState(false);
  const [notForOnlineSale, setNotForOnlineSale] = useState(false);
  const [awardCoins, setAwardCoins] = useState(false);
  const [billOnlyInStrip, setBillOnlyInStrip] = useState(false);
  const [mrpValue, setMrpValue] = useState(0);
  const [checkData, setCheckData] = useState({
    prescriptionRequired: false,
    eligibleForCoupon: false,
    isShindhiRecommended: false,
  });
  // -------image preview related state
  const [imgPreviewState, setImgPreviewState] = useState([]);

  // console.log("imgPreviewState", imgPreviewState);
  // ---------handle-image-delete---------
  const handleDeleteImages = (index) => {
    // console.log('first', index)
    setImgPreviewState((prev) => prev?.filter((item, ind) => ind !== index));
  };
  

const handleDeleteImage = (index) => {
  setImgPreviewState((prev) => prev.filter((_, ind) => ind !== index));
  setImageInputState((prev) => prev.filter((_, ind) => ind !== index));
  setImgFileNames((prev) => prev.filter((_, ind) => ind !== index));
};
  // console.log('checkData', checkData)
  const callMasterCategoryApi = async () => {
    const query = { type: "CATEGORY" };
    try {
      const {
        data: { status, code, data },
      } = await getMasterCategoryData(query);

      if (status || code === 200) {
        setMasterCategoryState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const callMasterSubCategoryApi = async () => {
  //   if (selectedCategoryOptionByAdmin) {
  //     const query = { categoryId: selectedCategoryOptionByAdmin };
  //     try {
  //       const {
  //         data: { status, code, data },
  //       } = await getMasterSubCategoryData(query);

  //       if (status || code === 200) {
  //         setMasterSubCategoryState(data);
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  // };
  const callMasterSubCategoryApi = async () => {
    if (selectedCategoryOptionByAdmin.length > 0) {
      const categoryArr = selectedCategoryOptionByAdmin.map(
        (item) => item?.value,
      );
      const query = {
        limit: 1000,
        category: categoryArr,
      };
      try {
        const {
          data: { status, code, data },
          // } = await getMasterSubCategoryData(query);
        } = await subCategoryListApi(query);

        if (status || code === 200) {
          setMasterSubCategoryState(data?.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    const fetchSubSubCategoryList = async () => {
      if (multiSelectOptions.length > 0) {
        console.log("call API");

        // Collect all selected subcategory IDs
        const subCategoryArr = multiSelectOptions.map((item) => item?.value);

        const query = {
          limit: 100,
          subcategories: subCategoryArr,
        };

        try {
          const {
            data: { status, code, data },
          } = await multiSubSubCategoryListApi(query);

          if (status || code === 200) {
            console.log("data", data);
            setSubSubCategoryList(data?.data || []);
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    fetchSubSubCategoryList();
  }, [multiSelectOptions]);

  const callMasterBrandApi = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getMasterBrandData();

      if (status || code === 200) {
        setMasterBrandState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callMasterProductType = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getMasterProductType();

      if (status || code === 200) {
        setMasterProductTypeState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callMasterUnitValueApi = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getMasterUnitValue();

      if (status || code === 200) {
        setMasterUnitState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    callMasterCategoryApi();
    // callMasterSubCategoryApi();
    callMasterBrandApi();
    callMasterProductType();
    callMasterUnitValueApi();
  }, []);

  useEffect(() => {
    callMasterSubCategoryApi();
  }, [selectedCategoryOptionByAdmin]);
  // Input Validation
  const validation = () => {
    let status = true;
    let errorObject = {};

    if (!imgInputState.length) {
      errorObject["imgEmptyErrorMsg"] = "Image is not Set";
      status = false;
    }

    if (!productName.length) {
      errorObject["productName"] = "Product Name is Required";
      status = false;
    }

    // if (!selectedBrandOptionByAdmin) {
    //   errorObject["selectedBrandOptionByAdmin"] = "Brand is Required";
    //   status = false;
    // }
    // if (!saltComposition.length) {
    //   errorObject["saltComposition"] = "Salt composition Name is Required";
    //   status = false;
    // }
    // if(!selectedBrandOptionByAdmin.length)
    // {
    //   errorObject["selectedBrandOptionByAdmin"] = "Brand is Required";
    //   status = false;
    // }

    if (!selectedProductTypeOptionByAdmin.length) {
      errorObject["selectedProductTypeOptionByAdmin"] =
        "Product Type is Required";
      status = false;
    }

    if (!selectedCategoryOptionByAdmin.length) {
      errorObject["selectedCategoryOptionByAdmin"] = "Category is Required";
      status = false;
    }

    if (!multiSelectOptions.length) {
      errorObject["multiSelectOptions"] = "Sub-Category is Required";
      status = false;
    }

    // if (!descriptionState.length) {
    //   errorObject["descriptionState"] = "Description is Required";
    //   status = false;
    // }

    if (!variants.length) {
      errorObject["variantError"] = "At least one variant is required";
      status = false;
    } else {
      variants.forEach((v, idx) => {
        const missingFields = [];
        if (!v.mrp?.toString().trim()) missingFields.push("MRP");
        if (!v.unit?.toString().trim()) missingFields.push("Unit");
        if (!v.unitValue?.toString().trim()) missingFields.push("Unit Value");
        // if (!v.quantity?.toString().trim()) missingFields.push("Quantity");
        if (!v.StockValue?.toString().trim()) missingFields.push("StockValue");

        if (missingFields.length) {
          errorObject[`variant_${idx}`] = `Variant ${
            idx + 1
          }: ${missingFields.join(", ")} required`;
          status = false;
        }
      });
    }

    setError(errorObject);

    return status;
  };

  const doSubmit = async () => {
    if (validation()) {
      const dataToSend = {
        ...checkData,
        name: productName,
        isDiscountAvailable: discountApply,
        discountPercentage: couponNumberState,
        // category: selectedCategoryOptionByAdmin,
        category: selectedCategoryOptionByAdmin?.map((mapPro) => mapPro.value),
        subcategory: multiSelectOptions.map((mapPro) => mapPro.value),
        subsubcategory: subSubCategoryValue.map((mapPro) => mapPro.value),
        brand: selectedBrandOptionByAdmin,
        image: imgInputState,
        description: descriptionState,
        productType: selectedProductTypeOptionByAdmin,
        saltComposition,
        variant: variants.map((mapProp) => {
          return {
            mrp: mapProp.mrp,
            isOutOfStock: mapProp.outOfStock,
            productType: selectedProductTypeOptionByAdmin,
            unit: mapProp.unit,
            unitValue: mapProp.unitValue,
            quantity: mapProp.quantity,
            stockValue: mapProp.StockValue,
            outOfStockValue:
              mapProp.outOfStockValue?.toString().trim() || "0",
            highStockValue:
              mapProp.highStockValue?.toString().trim() || "9999",
          };
        }),

        isHotDeal: hotDealApply,
        forOnlineSale: notForOnlineSale,
        awardCoin: awardCoins,
        billOnlyInStrip: billOnlyInStrip,
      };

      try {
        const {
          data: { status, code },
        } = await addNewProductApi(dataToSend);
        if (status || code === 200) {
          navigate("/product-management");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div className="add_products">
      {/* <Link to={-1} style={{ color: "#800080" }}>
        Product-Management
      </Link>
      /addNewProduct */}
      <div className="link-header-holder">
        <p>
          <Link to={-1}>
            <IoChevronBack />
            Back
          </Link>
          <span>Product-Management</span>
          &nbsp;
          <span>/ Add New Product </span>
        </p>
      </div>
      {/* <div style={{ textAlign: "right" }}>
        <button
          type="button"
          className="button"
          onClick={() => {
            navigate("/product-management");
          }}
        >
          Close
        </button>
      </div> */}
      <div className="card">
        {/* ---------------------------------right side */}
        <div className="form_field_wrap">
          <div className="form_field">
            <Input
              label="Product Name"
              placeholder="Product Name"
              value={productName}
              onChange={(e) => {
                setProductName(e.target.value);
              }}
             
            />

            {error["productName"] && (
              <div>
                <p className="error">{error["productName"]}</p>
              </div>
            )}
          </div>

          {/* all master select inputs */}
          {/* {masterBrandState.length > 0 && (
            <div className="form_field">
              <Select
                label="Select Brand"
                value={selectedBrandOptionByAdmin}
                onChange={(e) => {
                  setSelectedBrandOptionByAdmin(e.target.value);
                }}
              >
                <option value="">Select Brand</option>
                {masterBrandState.map((brandMapProp, ind) => (
                  <option value={brandMapProp._id} key={ind}>
                    {brandMapProp.name}
                  </option>
                ))}
              </Select>
            </div>
          )} */}

          <div className="form_field">
            <CommonSelect
              label="Select Brand"
              value={
                masterBrandState
                  .map((item) => ({ value: item._id, label: item.name }))
                  .find((item) => item.value === selectedBrandOptionByAdmin) ||
                null
              }
              onChange={(selectedOption) => {
                setSelectedBrandOptionByAdmin(selectedOption?.value || "");
              }}
              options={masterBrandState.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />
          </div>
          {/* --------------------master product type select */}

          {masterProductTypeState.length > 0 && (
            <div className="form_field">
              <CommonSelect
                label="Product Type"
                value={
                  masterProductTypeState
                    .map((item) => ({ value: item._id, label: item.name }))
                    .find(
                      (item) => item.value === selectedProductTypeOptionByAdmin,
                    ) || null
                }
                onChange={(selectedOption) => {
                  setSelectedProductTypeOptionByAdmin(
                    selectedOption?.value || "",
                  );
                }}
                options={masterProductTypeState.map((item) => ({
                  value: item._id,
                  label: item.name,
                }))}
                isSearchable={true}
                placeholder="Select Product Type"
              />

              {error["selectedProductTypeOptionByAdmin"] && (
                <div>
                  <p style={{ color: "red", marginTop: 4 }}>
                    {error["selectedProductTypeOptionByAdmin"]}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* -------------- masterCategoryState */}
          {/* {masterCategoryState.length > 0 && (
            <div className="form_field">
              <Select
                label="Category Name"
                value={selectedCategoryOptionByAdmin}
                onChange={(e) => {
                  setSelectedCategoryOptionByAdmin(e.target.value);
                }}
              >
                <option value="">Select Category</option>
                {masterCategoryState.map((categoryMapProp, ind) => (
                  <option value={categoryMapProp._id} key={ind + 2}>
                    {categoryMapProp.name}
                  </option>
                ))}
              </Select>

              {error["selectedCategoryOptionByAdmin"] && (
                <div>
                  <p style={{ color: "red", marginTop: 4 }}>
                    {error["selectedCategoryOptionByAdmin"]}
                  </p>
                </div>
              )}
            </div>
          )} */}

          <div className="form_field">
            <CommonSelect
              value={selectedCategoryOptionByAdmin || []}
              label="Category Name"
              name="SubCategoryName"
              isMulti={true}
              onChange={(commonSelectData) => {
                setSelectedCategoryOptionByAdmin(commonSelectData);
                setMultiSelectOptions([]);
                setSubSubCategoryValue([]);
              }}
              // options={[
              //   { value: "apple", label: "Apple" },
              //   { value: "banana", label: "Banana" },
              //   { value: "mango", label: "Mango" },
              //   { value: "grape", label: "Grape" },
              // ]}
              options={masterCategoryState.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />

            {error["selectedCategoryOptionByAdmin"] && (
              <div>
                <p style={{ color: "red", marginTop: 4 }}>
                  {error["selectedCategoryOptionByAdmin"]}
                </p>
              </div>
            )}
          </div>

          {/* ---------------masterSubCategoryState  */}

          {/* {masterSubCategoryState.length > 0 && ( */}
          <div className="form_field">
            <CommonSelect
              value={multiSelectOptions || []}
              label="Sub-Category Name"
              name="SubCategoryName"
              isMulti={true}
              onChange={(commonSelectData) => {
                setMultiSelectOptions(commonSelectData);
                setSubSubCategoryValue([]);
              }}
              // options={[
              //   { value: "apple", label: "Apple" },
              //   { value: "banana", label: "Banana" },
              //   { value: "mango", label: "Mango" },
              //   { value: "grape", label: "Grape" },
              // ]}
              options={masterSubCategoryState.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />

            {error["multiSelectOptions"] && (
              <div>
                <p className="error">{error["multiSelectOptions"]}</p>
              </div>
            )}
          </div>
          <div className="form_field">
            <CommonSelect
              value={subSubCategoryValue || []}
              label="Filter Category Name"
              name="subsubcategory"
              isMulti={true}
              onChange={(commonSelectData) => {
                setSubSubCategoryValue(commonSelectData);
              }}
              options={(subSubCategoryList || [])?.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />
          </div>
          <div className="form_field">
            <TextArea
              label="salt Composition"
              placeholder="salt Composition"
              name="saltComposition"
              value={saltComposition}
              onChange={(e) => {
                setSaltComposition(e.target.value);
              }}
              
            />
          </div>
          {/* )} */}
          <div className="form_field w-100">
            {/* <TextArea
              label="Description"
              value={descriptionState}
              placeholder="Description"
              onChange={(e) => {
                setDescriptionState(e.target.value);
              }}
              maxLength={200}
            /> */}
            <label htmlFor="">Description</label>
            <JoditEditor
              ref={editor}
              value={descriptionState}
              tabIndex={1}
              onBlur={(newContent) => setDescriptionState(newContent)}
              config={{
                readonly: false,
                height: 200,
                placeholder: "Edit content here...",
              }}
            />
            {error["descriptionState"] && (
              <div>
                <p className="error">{error["descriptionState"]}</p>
              </div>
            )}
          </div>
        </div>

        {/* --------------------Description ------------- */}

        <div className="form_field_wrap">
          <DynamicInputField
            variants={variants}
            setVariants={setVariants}
            blank={blank}
            masterUnitState={masterUnitState}
            error={error}
          />
        </div>

        {/* -----------stock value */}

        {/* ------------------------------left side part starts */}
        <div className="form_field_wrap">
    <div className="form_field">
  <label className="label">Upload Image</label>

  <div className="file-upload-row">
    <input
      id="productImageUpload"
      onChange={imgUploadFunction}
      type="file"
      accept="image/*"
      className="form-control input"
      multiple
      style={{ display: "none" }}
    />

    <label htmlFor="productImageUpload" className="custom-file-upload">
      Choose files
    </label>

    <span className="chosen-file-text">
      {imgFileNames.length > 0
        ? imgFileNames.join(", ")
        : "No file chosen"}
    </span>
  </div>

  {error["imgEmptyErrorMsg"] && (
    <span className="error">{error["imgEmptyErrorMsg"]}</span>
  )}
  {error["imgErrorOccur"] && (
    <p className="error">{error["imgErrorOccur"]}</p>
  )}

  <div className="image_preview multi_preview">
    {imgPreviewState.length > 0 &&
      imgPreviewState.map((imag, ind) => (
        <div key={ind} className="item">
          <MdOutlineCancel onClick={() => handleDeleteImage(ind)} />
          <ImagePreview file={imag} key={ind} />
        </div>
      ))}
  </div>
</div>

          {/* ----end of img preview component */}

          {/* ------------set coupon and checkbox  */}
          <div className="form_field">
            <label htmlFor="couponIdApply" className="label">
              <input
                id="couponIdApply"
                type="checkbox"
                onChange={(e) => {
                  setDiscountApply(e.target.checked);
                  if (!e.target.checked) {
                    setCouponNumberState(0); // Reset the state itself
                  }
                }}
                value={discountApply}
                checked={discountApply}
              />{" "}
              Apply Discount(%)
            </label>

            <Input
              type="text"
              name="couponNumber"
              value={couponNumberState}
              // onChange={(e) => {
              //   setCouponNumberState(e.target.value);
              // }}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only numbers using regex
                if (/^\d*$/.test(value)) {
                  setCouponNumberState(value);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              disabled={!discountApply}
              maxLength={2}
            />
            <div className="select_list">
              {/* ------------set coupon and checkbox  */}
              <label htmlFor="markInHotDealIdApply">
                <input
                  id="markInHotDealIdApply"
                  type="checkbox"
                  onChange={(e) => {
                    setHotDealApply(e.target.checked);
                  }}
                  value={hotDealApply}
                  checked={hotDealApply}
                />{" "}
                Mark In Hot Deals
              </label>

              <label htmlFor="notForSaleId">
                <input
                  id="notForSaleId"
                  type="checkbox"
                  value={notForOnlineSale}
                  onChange={(e) => {
                    setNotForOnlineSale(e.target.checked);
                  }}
                  checked={notForOnlineSale}
                />{" "}
                Not For Online Sales
              </label>

              {/* --------award coins */}
              <label htmlFor="forAwardCoinId">
                <input
                  id="forAwardCoinId"
                  type="checkbox"
                  value={awardCoins}
                  onChange={(e) => {
                    setAwardCoins(e.target.checked);
                  }}
                  checked={awardCoins}
                />{" "}
                Award Coins
              </label>

              <label htmlFor="prescriptionRequired">
                <input
                  id="prescriptionRequired"
                  type="checkbox"
                  checked={checkData.prescriptionRequired}
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      prescriptionRequired: e.target.checked,
                    })
                  }
                />{" "}
                {"Prescription Required/OTC (Over the Counter)"}
              </label>

              <label htmlFor="eligibleForCoupon">
                <input
                  id="eligibleForCoupon"
                  type="checkbox"
                  checked={checkData.eligibleForCoupon}
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      eligibleForCoupon: e.target.checked,
                    })
                  }
                />{" "}
                Eligible for Coupon
              </label>

              <label htmlFor="isShindhiRecommended">
                <input
                  id="isShindhiRecommended"
                  type="checkbox"
                  checked={checkData.isShindhiRecommended}
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      isShindhiRecommended: e.target.checked,
                    })
                  }
                />{" "}
                sindhi Recommended
              </label>
              <label htmlFor="billOnlyInStrip">
                <input
                  id="billOnlyInStrip"
                  type="checkbox"
                  value={billOnlyInStrip}
                  onChange={(e) => {
                    setBillOnlyInStrip(e.target.checked);
                  }}
                  checked={billOnlyInStrip}
                />{" "}
                Bill Only In Strip
              </label>
            </div>
          </div>

          {/* ----------------mark in hot deal */}
        </div>

        {/* --------add product  */}
        <div className="button_wrap">
          <button className="button" type="button" onClick={doSubmit}>
            Add Product
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNewProduct;

const DynamicInputField = ({
  variants,
  setVariants,
  blank,
  masterUnitState,
  error,
}) => {
  console.log("setVariants---->", variants);
  const update = (id, key, val) =>
    setVariants((cur) =>
      cur.map((v) => (v.id === id ? { ...v, [key]: val } : v)),
    );

  const add = () => setVariants((cur) => [...cur, blank()]);
  const remove = (id) =>
    setVariants((cur) =>
      cur.length > 1 ? cur.filter((v) => v.id !== id) : cur,
    );

  return (
    <>
      {variants.map((v, i) => (
        <div key={i} className="append_list">
          <div className="form_field">
            {/* <Input
              type="text"
              label="MRP"
              placeholder="MRP"
              value={v.mrp}
              // onChange={(e) => update(v.id, "mrp", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v.id, "mrp", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            /> */}




            <Input
  type="text"
  label="MRP"
  placeholder="MRP"
  value={v.mrp}
  inputMode="decimal"
  maxLength={12}
  onChange={(e) => {
    let input = e.target.value.replace(/\s+/g, "");

    // Allow only numbers with up to 2 decimal places
    if (/^\d*\.?\d{0,2}$/.test(input)) {
      update(v.id, "mrp", input);
    }
  }}
  onKeyDown={(e) => {
    // Prevent scientific notation and negative values
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }

    // Allow only one decimal point
    if (e.key === "." && e.currentTarget.value.includes(".")) {
      e.preventDefault();
    }
  }}
/>
            {error[`variant_${i}`] && (
              <p className="error" style={{ color: "red" }}>
                {error[`variant_${i}`]}
              </p>
            )}
          </div>
          <div className="form_field">
            <CommonSelect
              value={
                masterUnitState
                  .map((unit) => ({ value: unit.name, label: unit.name }))
                  .find((item) => item.value === v.unit) || null
              }
              label="Product Pack Form"
              onChange={(selectedOption) => {
                update(v.id, "unit", selectedOption?.value || "");
              }}
              options={masterUnitState.map((unit) => ({
                value: unit.name,
                label: unit.name,
              }))}
              isSearchable={true}
              placeholder="Product Pack Form"
            />
          </div>

          <div className="form_field">
            <Input
              type="text"
              label="Per Product Size "
              placeholder="Per Product Size (supports decimals like 2.5 ml, 0.5 gm)"
              value={v.unitValue}
              // onChange={(e) => update(v.id, "unitValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v.id, "unitValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>
          {false && (
            <div className="form_field">
              <Input
                type="text"
                label=" Minus Stock Quantity"
                placeholder="Minus Stock Quantity"
                value={v.quantity}
                // onChange={(e) => update(v.id, "quantity", e.target.value)}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={9}
                onChange={(e) => {
                  let input = e.target.value;
                  input = input.replace(/\s+/g, "");
                  if (/^\d*\.?\d{0,2}$/.test(input)) {
                    update(v.id, "quantity", input);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-", "."].includes(e.key))
                    e.preventDefault();
                }}
              />
            </div>
          )}
          {/* <Input
            type="number"
            placeholder="Stock"
            value={v.stock}
            onChange={(e) => update(v.id, "stock", e.target.value)}
            onKeyDown={(e) => {
              if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
            }}
          /> */}
          <div className="form_field">
            <Input
              type="text"
              label="Current Stock Quantity
"
              placeholder="Current Stock Quantity
"
              value={v.StockValue}
              // onChange={(e) => update(v.id, "StockValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v.id, "StockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <Input
              type="text"
              label="Minimum Stock Quantity"
              placeholder="Minimum Stock Quantity"
              value={v.outOfStockValue || ""}
              // onChange={(e) => update(v._id, "outOfStockValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              name="extraStockValue"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v.id, "outOfStockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <Input
              type="text"
              label=" Maximum Stock Quantity"
              placeholder=" Maximum Stock Quantity"
              value={v.highStockValue || ""}
              // onChange={(e) => update(v._id, "outOfStockValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v.id, "highStockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <label className="label dummy">Dummy</label>
            <label>
              <input
                type="checkbox"
                checked={v.outOfStock}
                onChange={(e) => update(v.id, "outOfStock", e.target.checked)}
                className="me-1"
              />
              Mark Out of Stock
            </label>
          </div>
          {variants.length > 1 && (
            <div className="form_field">
              <button
                style={{ marginTop: "1rem" }}
                type="button"
                className="button"
                onClick={() => remove(v.id)}
              >
                Remove
              </button>
            </div>
          )}
        </div>
      ))}

      {/* <div className="button_wrap button_right">
        <button type="button" className="button" onClick={add}>
          + Add another variant
        </button>
      </div> */}
    </>
  );
};
